/* eslint-disable sonarjs/no-hardcoded-passwords -- 이 파일의 "password" 값들은 자격증명이 아니라 i18n 번역 키 문자열이다 */
import { CONFIRM } from "../dialogMessage";

export const LOGIN = "login";
export const LOGOUT = "logout";

// FIXME: 다국어지원
export const TEXT = {
  // 구글 로그인
  googleLogin: "login_google",

  // 애플 로그인
  appleLogin: "login_apple",

  // 전화번호로 시작하기
  phoneNumberLogin: {
    title: "login_phone_number", // "Start with phone number",
    placeholder: {
      // 전화번호 사용자일 경우 - 전화번호 입력 인풋_플레이스 홀더
      phoneNumber: "phone_number_placeholder",
      // 전화번호 사용자일 경우 - 비밀번호 입력 인풋_플레이스 홀더
      password: "password_hint_4_number", // "Please enter a 4-digit number",
    },
    button: {
      common: LOGIN,
      confirm: CONFIRM,
    },
  },

  // 이메일로 시작하기
  emailLogin: {
    title: "login_email", // "Start with email",
    placeholder: {
      // 이메일 사용자일 경우 - 이메일 입력 인풋_플레이스 홀더
      email: "email_placeholder",
      // 이메일 사용자일 경우 - 비밀번호 입력 인풋_플레이스 홀더
      password: "password_hint_min_6_characters", // "Please enter a 4-digit number",
    },
    button: {
      common: LOGIN,
      confirm: CONFIRM,
    },
  },

  // 로그인
  login: LOGIN,

  // 로그아웃
  logout: LOGOUT,

  // 회원탈퇴
  deleteUserAccount: "account_delete",

  // 비밀번호 재확인
  confirmPassword: "confirm_password",

  // 비밀번호 초기화
  resetPassword: ["forget_password", "password_reset"],

  header: {
    login: "welcome",
  },
};
